import React from 'react';

export const CategoryLoader: React.FC = React.memo(() => {
    return <React.Fragment></React.Fragment>;
});
